import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'

class ColumnSwitcher extends BaseComponent {
  itemSelector: string
  targetSelector: string
  items: Element[]
  cssVariable: string

  constructor() {
    super()

    this.itemSelector = `[data-column-switcher-item]`
    this.targetSelector = `[data-column-switcher-target]`

    this.items = [...this.querySelectorAll(this.itemSelector)]

    this.cssVariable = this.dataset.columnSwitcherCssVariable || ''
  }

  connectedCallback(): void {
    window.addEventListener('load', this.handleWindowLoad)

    this.items.forEach(item => {
      item.addEventListener('keydown', this.handleKeyDown)
      item.addEventListener('click', this.handleItemClick)
    })

    if (this.isEditorMode) {
      this.editor.subscribe('SECTION_LOAD', this.handleSectionLoad)
    }
  }

  disconnectedCallback(): void {
    window.removeEventListener('load', this.handleWindowLoad)

    this.items.forEach(item => {
      item.removeEventListener('keydown', this.handleKeyDown)
      item.removeEventListener('click', this.handleItemClick)
    })

    if (this.isEditorMode) {
      this.editor.destroy()
    }
  }

  handleWindowLoad = (): void => {
    if (!this.isEditorMode) {
      this.init()
    }
  }

  handleSectionLoad = (event): void => {
    if (this.dataset.sectionId === event.detail.sectionId) {
      this.reset()
    }
  }

  handleItemClick = (event: MouseEvent): void => {
    const eventTarget = event.target as HTMLElement
    const target = eventTarget.closest<HTMLElement>(this.itemSelector)

    if (target) {
      const columnCount = +(target.dataset.value || 1)

      this.switch(columnCount)
    }
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      const eventTarget = event.target as HTMLElement
      const target = eventTarget.closest<HTMLElement>(this.itemSelector)

      if (target) {
        const columnCount = +(target.dataset.value || 1)

        this.switch(columnCount)
      }
    }
  }

  updateByColumnCount(columnCount: number): void {
    this.selectSwitch(columnCount)
    this.updateColumnCount(columnCount)
  }

  selectSwitch(columnCount: number): void {
    this.items.forEach(item => {
      const value = +(item.getAttribute('data-value') || 1)

      item.classList.toggle('selected', value === columnCount)
    })
  }

  updateColumnCount(value: number): void {
    const target = this.closest<HTMLElement>(this.targetSelector)

    if (target) {
      target.style.setProperty(`--gsc-${this.cssVariable}`, value.toString())
      localStorage.setItem(`products-${this.cssVariable}`, value.toString())
    }
  }

  init(): void {
    const value = localStorage.getItem(`products-${this.cssVariable}`)

    if (!value || value === 'null') {
      return
    }

    const preparedValue = Number(value)

    if (preparedValue > 0) {
      this.updateByColumnCount(preparedValue)
    }
  }

  switch(columnCount: number): void {
    this.updateByColumnCount(columnCount)
  }

  reset(): void {
    if (!this.dataset.default) {
      return
    }

    this.switch(Number(this.dataset.default))
  }
}

export default ColumnSwitcher
